import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { createOrder, approveNFT, mintNFT, registerNFT, createAuction, approveSingleAuctionOrder } from '../../../api/nft/nft';
import { connect } from 'react-redux';
import { mnemonicValidate } from '@polkadot/util-crypto';
import { Keyring } from '@polkadot/api';
import { getNSTBalanceApi } from '../../../api/wallet/wallet';
import KycStatus from '../../Layouts/KycStatus/KycStatus';
import MissingMnemonics from '../../Layouts/MissingMnemonics/MissingMnemonics';
import ContinueWithPassword from '../../Layouts/ContinueWithPassword/ContinueWithPassword';
import CryptoJS from 'crypto-js';
import { setCypherSecret } from '../../../actions/auth';
import NotLoggedInRedirection from '../../Auth/NotLoggedInRedirection/NotLoggedInRedirection';
import PageLoader from '../../Layouts/PageLoader/PageLoader';
import PermissionRequired from '../../Layouts/PermissionRequired/PermissionRequired';
import { errorMessageHandler, isVideo } from '../../../utils/utils';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

const INITIAL_STATE = {
    data: {
        image: null,
        title: '',
        description: '',
        price: '',
        noOfCopies: 1,
        minBid: null,
        startTime: null,
        endTime: null,
        royalties: 10,
        marketType: 'FIXED PRICE',
        isAvailableForMarket: true,
        unlockOncePurchased: false,
        properties: {
            size: null,
            type: null
        },
        uploadType: null,
        radeemLink: null,
        alternativeText: null
    },
    imgSrc: null,
    showAdvance: false,
    isError: false,
    message: null,
    isLoading: false,
    mnemonics: null,
    step: 1,
    message_list: [],
    blockHash: null,
    public_address: null,
    balance: null,
    saveMyMnemonics: false,
    mnemonicsPwd: '',
    passwordError: ""
}

class Rea extends Component {

    state = {
        ...INITIAL_STATE
    }



    componentDidMount() {
        console.log("this.props.currentUser", this.props.currentUser, this.props.token)


        // if (!this.props.token) return;

        getNSTBalanceApi(this.props.token).then(({ data: { balance } }) => {
            this.setState({ ...this.state, balance: balance });
        }).catch(e => { });

        if (localStorage.getItem('theme') === 'dark') {
            $(".modal").addClass("DarkModal");
            $(".dropdown-menu").addClass("dropdown-menu-dark");
        }
    }



    onChangeMnemonics = e => {
        e.preventDefault();
        if (mnemonicValidate(e.target.value)) {
            const keyring = new Keyring({
                type: 'sr25519',
                ss58Format: 42,
            });
            const newPair = keyring.addFromUri(e.target.value);
            this.setState({ ...this.state, mnemonics: e.target.value, public_address: newPair.address });
        } else this.setState({ ...this.state, mnemonics: e.target.value, public_address: null });
    }

    onUploadFile = e => {
        const file = e.target.files[0];

        const reader = new FileReader();
        const url = reader.readAsDataURL(file);

        if ((file.size / 1024) / 1024 > 100) {
            document.getElementById('launch-modal-btn').click();
            return;
        }

        reader.onloadend = function (e) {
            this.setState({ ...this.state, imgSrc: reader.result, data: { ...this.state.data, image: file, uploadType: file.type } })
        }.bind(this);
    }

    oc = e => {
        if (e.target.name === 'isAvailableForMarket') this.setState({ ...this.state, data: { ...this.state.data, [e.target.name]: !this.state.data.isAvailableForMarket } });
        else if (e.target.name === 'unlockOncePurchased') this.setState({ ...this.state, data: { ...this.state.data, [e.target.name]: !this.state.data.unlockOncePurchased } });
        else if (e.target.name === 'showAdvance') this.setState({ ...this.state, [e.target.name]: !this.state.showAdvance });
        else if (e.target.name === 'startTime' || e.target.name === 'endTime') this.setState({ ...this.state, data: { ...this.state.data, [e.target.name]: e.target.value } });
        else this.setState({ ...this.state, data: { ...this.state.data, [e.target.name]: e.target.value } });
    }



    componentWillReceiveProps(nextProps) {
        if (nextProps.toggle.toggle_create_nft !== this.props.toggle.toggle_create_nft) {
            setTimeout(() => {
                if (localStorage.getItem('theme') === 'dark') {
                    $(".modal").addClass("DarkModal");
                    $(".dropdown-menu").addClass("dropdown-menu-dark");
                }
            }, 100)
        }
    }

    async submit(e) {
        // e.preventDefault();
        if (!this.props.currentUser.public_address) {
            return document.getElementById('confirmationMissingMnemonicsBtn').click();
        }



        const { title, description, royalties, image, marketType, price, minBid, startTime, endTime } = this.state.data;

        if (image === null)
            return this.setState({ ...this.state, isError: true, message: 'Media file is required!' });

        else if (!title)
            return this.setState({ ...this.state, isError: true, message: 'Title field is required!' });
        else if (!description)
            return this.setState({ ...this.state, isError: true, message: 'Description field is required!' });



        switch (marketType) {
            case 'FIXED PRICE': {
                try {
                    const _price = parseFloat(price);

                    if (Number.isNaN(_price) || _price <= 0) {
                        return this.setState({ ...this.state, isError: true, message: 'Price must be a positive number greater than zero.' });
                    }
                } catch (e) {
                    return this.setState({ ...this.state, isError: true, message: 'Price must be a positive number.' });
                };
                break;
            }
            case 'Timed Auction': {
                try {
                    const _minBid = parseFloat(minBid);

                    if (Number.isNaN(_minBid) || _minBid < 0) {
                        return this.setState({ ...this.state, isError: true, message: 'Minimum Bid must be a positive number.' });
                    }

                    if (startTime === null || endTime === null) {
                        return this.setState({ ...this.state, isError: true, message: 'Auction start and end time must be provided.' });
                    }

                    if (new Date(startTime).getTime() > new Date(endTime).getTime()) {
                        return this.setState({ ...this.state, isError: true, message: 'Auction start time cannot be greater than end time.' });
                    }

                    if (new Date(startTime).getTime() < Date.now() && `${new Date(startTime).getDate()}-${new Date(startTime).getMonth() + 1}-${new Date(startTime).getFullYear()}` !== `${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}`) {
                        return this.setState({ ...this.state, isError: true, message: 'Auction start time must be greater or equal to current date/time.' });
                    }

                    if (new Date(endTime).getTime() <= Date.now()) {
                        return this.setState({ ...this.state, isError: true, message: 'Auction end time must be greater then current date/time.' });
                    }
                } catch (e) {
                    return this.setState({ ...this.state, isError: true, message: 'Minimum Bid must be a positive number.' });
                };
                break;
            }
        }

        try {
            const _royalities = parseInt(royalties);
            if (Number.isNaN(_royalities)) {
                return this.setState({ ...this.state, isError: true, message: 'Royalities must a number!' });
            }
            if (_royalities < 0 || _royalities > 50) {
                return this.setState({ ...this.state, isError: true, message: 'Royalities are must be 0%, 10%, 20%, 30%. Maximum is 50%' });
            }
        } catch (e) {
            return this.setState({ ...this.state, isError: true, message: 'Royalities must a number!' });
        }


        this.setState({ ...this.state, isLoading: false, isError: false, message: null });

        document.getElementById('confirmationModalBtn').click();
    }

    resetModalState = () => {
        this.setState({ ...this.state, mnemonics: '', public_address: null, mnemonicsPwd: '', saveMyMnemonics: false, passwordError: "" })
    }

    processAPI = async () => {


        if (this.state.saveMyMnemonics) {
            const cypher = CryptoJS.AES.encrypt(this.state.mnemonics, this.state.mnemonicsPwd).toString();
            this.props.setCypherSecret(cypher);
        }


        document.getElementById('confirmationModalBtn').click();

        setTimeout(() => {
            document.getElementById('stepsModalBtn').click();
        }, 200);

        const { title, description, royalties, image, marketType, price, minBid, startTime, endTime } = this.state.data;

        this.setState({ ...this.state, isLoading: true, isError: false, message: null, step: 2 });

        const dataBody = this.state.data;

        const formData = new FormData();
        formData.append('image', image);
        formData.append('data', JSON.stringify(dataBody));
        formData.append('secret', this.state.mnemonics);


        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        console.log("Token is", this.props.token)


        return


        try {
            let message_list = [];
            const response = await registerNFT(formData, this.props.token);
            const { orderId, tokenId, blockchainTokenId } = response.data.data
            message_list.push({ ...response.data.data, title: 'NFT Minted!' });
            this.setState({ ...this.state, message: null, step: 3 });

            const orderResponse = await createOrder({
                secret: this.state.mnemonics,
                orderId: orderId,
                tokenId: tokenId,
                blockchainTokenId
            }, this.props.token)

            message_list.push({ ...orderResponse.data.data, title: 'Order Created!' });
            this.setState({ ...this.state, step: 4, message_list: message_list, message: null, isLoading: false });
            this.resetModalState()

        } catch (e) {
            console.log("reacc err", e)
            this.resetModalState()
            this.setState({ ...this.state, blockHash: null, isLoading: false, isError: true, message: errorMessageHandler(e) });
        }
    }

    infoModal = () => {
        return (
            <React.Fragment>
                <button style={{ display: 'none' }} id="launch-modal-btn" type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    Launch demo modal
                </button>
                <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">File Size</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                File size must be equal or less then 100mb.
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    confirmationModal = () => (

        <React.Fragment>
            <button style={{ display: 'none' }} id="confirmationModalBtn" type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#confirmationModal">
                Launch demo modal
            </button>
            {console.log("fifif", this?.state?.public_address?.toLowerCase(), this?.props?.currentUser?.public_address?.toLowerCase(), mnemonicValidate(this.state.mnemonics))}
            <div className="modal fade" id="confirmationModal" tabIndex="-1" aria-labelledby="confirmationModalLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className={this.props.cypherSecret === null ? "modal-content" : "modal-content d-none"}>
                        <div className="modal-header align-items-start">
                            <h5 className="modal-title" id="confirmationModalLabel">Please enter your account mnemonics to confirm transaction</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label CeraMed d-block mb-1">Account Mnemonics</label>
                                <textarea style={{ borderColor: !this.state.mnemonics ? '' : mnemonicValidate(this.state.mnemonics) && this.state.public_address && this.state.public_address.toLowerCase() === this?.props?.currentUser?.public_address?.toLowerCase() ? 'green' : 'red' }} onChange={this.onChangeMnemonics} value={this.state.mnemonics} name="mnemonics" rows="4" className="form-control shadow-none"
                                    placeholder="Paste your mnemonics here"></textarea>
                                <p className="form-text mb-0">We are not storing your private key, this can be use one time for this transaction.</p>
                            </div>
                            <React.Fragment>
                                {
                                    this.state.public_address && this.state.public_address.toLowerCase() === this?.props?.currentUser?.public_address?.toLowerCase() && (
                                        <React.Fragment>
                                            <strong className={'text-success d-block'}>Looks Good!</strong> Your public address matched <strong className={'break-all d-block'}>{this.state.public_address}</strong>
                                        </React.Fragment>
                                    )
                                }
                                {
                                    this.state.public_address && this.state.public_address.toLowerCase() !== this?.props?.currentUser?.public_address?.toLowerCase() && (
                                        <React.Fragment>
                                            {this.state.public_address}<br />
                                            <strong className={'text-danger d-block'}>Something Wrong!</strong> Your profile address is not matching with the provided Mnemonics, Please add the mnemonics which you give us on sign up.
                                        </React.Fragment>
                                    )
                                }
                            </React.Fragment>
                            <div className="form-check pt-3">
                                <input checked={this.state.saveMyMnemonics} onClick={() => this.setState({ ...this.state, saveMyMnemonics: !this.state.saveMyMnemonics })} className="form-check-input shadow-none" type="checkbox" id="mnemonicsForSingleNFT" />
                                <label className="form-check-label" htmlFor="mnemonicsForSingleNFT">
                                    Encrypt and save my mnemonics on browser for future transactions!
                                </label>
                            </div>
                            <div className="px-0">
                                {this.state.saveMyMnemonics && (
                                    <input
                                        value={this.state.mnemonicsPwd}
                                        onChange={e => {
                                            const value = e.target.value;
                                            this.setState({ mnemonicsPwd: value });

                                            if (value.length < 6) {
                                                this.setState({ passwordError: "Password is too weak" });
                                            } else {
                                                this.setState({ passwordError: "" });
                                            }
                                        }}
                                        className="form-control BorderDarkGrey shadow-none mt-4"
                                        type="password"
                                        name="password"
                                        placeholder="Enter Password"
                                    />
                                )}
                                {
                                    this.state.passwordError && <strong className={'text-danger d-block'}>{this.state.passwordError}</strong>

                                }

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => {
                                this.resetModalState()


                            }
                            } type="button" className="btn BtnBorderBlack py-2 px-4 px-sm-5" data-bs-dismiss="modal">Close</button>
                            <button


                                disabled={!mnemonicValidate(this.state.mnemonics) || this.state.public_address && this.state.public_address.toLowerCase() !== this.props.currentUser.public_address.toLowerCase() || (this.state.saveMyMnemonics ? this.state.mnemonicsPwd.length < 6 : false)} onClick={this.processAPI.bind(this)} type="button" className="btn BtnBlack py-2 px-4 px-sm-5" style={{ opacity: (!mnemonicValidate(this.state.mnemonics) || this.state.public_address && this.state.public_address.toLowerCase() !== this.props.currentUser.public_address.toLowerCase() || (this.state.saveMyMnemonics ? this.state.mnemonicsPwd.length < 6 : false)) ? 0.3 : 1 }}>Confirm</button>

                        </div>
                    </div>
                    <div className={this.props.cypherSecret !== null ? "modal-content" : "modal-content d-none"}>
                        <div className="modal-body">
                            <ContinueWithPassword callback={(mnemonics) => {
                                this.setState({ ...this.state, mnemonics, mnemonics }, () => {
                                    this.processAPI();
                                });
                            }} />
                        </div>
                    </div>
                </div>
            </div>



        </React.Fragment>
    )

    // TODO replace error with information

    stepMessages = (step) => {

        if (this.state.isError) {
            return (
                <div className="text-center Fsize_16">
                    <h3 className="text-center"><span className="far fa-times-circle fit-image text-danger" /> Information!</h3>
                    <p className={'text-danger d-block'}>
                        {
                            this.state.message
                        }
                    </p>
                    <button onClick={() => {
                        this.setState({ ...this.state, mnemonics: null, step: 1, message_list: [], blockHash: null, isError: false, message: null })
                    }} data-bs-toggle="modal" data-bs-target="#StepsModal" type="button" className="btn BtnBlack py-2 px-5">OK</button>
                </div>
            )
        }
        console.log("this.state.blockHash", this.state.blockHash, this.state.message_list)

        // const { blockHash, status, data: { tokenId } } = this.state.blockHash || { data: {} };

        switch (step) {
            case 1:
                return (
                    <div className="text-center">
                        <h3>Saving Information</h3>
                        <p>Preparing for NFT Creation...</p>
                    </div>
                )
            case 2:
                return (
                    <div className="text-center">
                        <h3>Minting NFT Token</h3>
                        <p>Please wait, we are creating NFT</p>

                    </div>
                )
            case 3:
                return (

                    <div className="text-center">
                        <h3>Adding NFT Order</h3>
                        <p>Please wait, Creating new order</p>

                    </div>

                )

            case 4:
                return (
                    <div className="text-center">
                        {

                            <React.Fragment>
                                {
                                    this.state.message_list.map((item) => (
                                        <React.Fragment>
                                            <h3><span className="fas fa-check-circle text-success" /> Success !</h3>
                                            <p>
                                                <strong>Message </strong> {item.title}<br />
                                                <strong>Block Hash </strong> <a className={'WhiteForDarkMode break-all'} target="_blank" href={`${process.env.REACT_APP_NFT_EXPLORER}/block/${item?.blockHash}`}>{item?.blockHash}</a> <br />
                                                {item.tokenId && <p> <strong>Token ID </strong> {item.tokenId}</p>}
                                            </p>
                                        </React.Fragment>
                                    ))
                                }

                            </React.Fragment>

                        }

                        <button onClick={() => {
                            this.setState({ ...INITIAL_STATE });
                            // this.setState({ ...this.state, mnemonics: null, step: 1, message_list: [], blockHash: null, isError: false, message: null })
                        }} data-bs-toggle="modal" data-bs-target="#StepsModal" type="button" className="btn BtnBlack py-2 px-5">OK</button>
                    </div>
                )
        }
    }

    stepsModal = () => {

        const { step, isLoading, isError } = this.state;

        return (
            <React.Fragment>
                <button id="stepsModalBtn" style={{ display: 'none' }} type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#StepsModal">
                    Launch Steps modal
                </button>
                <div className="modal fade" id="StepsModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="StepsModalLabel" aria-hidden="true">
                    <div style={{ minWidth: '70%' }} className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="StepsModalLabel">{isLoading ? 'Processing...' : isError ? 'Information' : 'Done!'} {isLoading && <i className="fas fa-asterisk fa-spin"></i>}</h5>
                                {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
                            </div>
                            <div className="modal-body">
                                <form id="msform">
                                    <ul id="progressbar" className="ps-0">
                                        <li className={step > 0 ? 'active' : ''} id="account"><strong>Saving Information</strong></li>
                                        <li className={step > 1 ? 'active' : ''} id="personal"><strong>Mint NFT</strong></li>
                                        {/* <li className={step > 2 ? 'active' : ''} id="approval"><strong>Approve NFT</strong></li> */}
                                        <li className={step > 2 ? 'active' : ''} id="payment"><strong>Creating Order</strong></li>
                                        <li className={step > 3 ? 'active' : ''} id="confirm"><strong>Finish</strong></li>
                                    </ul>
                                    {
                                        this.stepMessages(step)
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    render() {
        const { isAvailableForMarket, unlockOncePurchased, marketType, title, description, royalties } = this.state.data;

        if (this.props.toggle.toggle_create_nft === undefined) return <PageLoader />
        if (!this.props.toggle.toggle_create_nft) return <PermissionRequired />

        return (
            <main>
                <section id="CreateCollectible" className={'py-5'}>
                    <div className="container">
                        <div className="row justify-content-center gx-3" id='zIndexMob'>
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-9 col-xxl-9 Fsize_16">
                                <Link to="/create" className="Fsize_16  brandnew">
                                    <svg className="mb-1 me-2" viewBox="0 0 14 12" fill="none" width="14" height="14"
                                        xlmns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M6.29436 0.292893C6.68488 -0.0976311 7.31805 -0.0976311 7.70857 0.292893C8.0991 0.683417 8.0991 1.31658 7.70857 1.70711L4.41568 5H12.9985C13.5508 5 13.9985 5.44772 13.9985 6C13.9985 6.55228 13.5508 7 12.9985 7H4.41568L7.70857 10.2929C8.0991 10.6834 8.0991 11.3166 7.70857 11.7071C7.31805 12.0976 6.68488 12.0976 6.29436 11.7071L0.587252 6L6.29436 0.292893Z"
                                            fill="currentColor"></path>
                                    </svg>
                                    Manage collectible type
                                </Link>
                                <h2 className="mb-4 pt-2">Create single collectible lvlvl</h2>
                                <div className="row mb-4">
                                    <div className="col-lg-8 mb-3 mb-sm-0">
                                        <div className="mb-3">
                                            <label className="form-label CeraMed">Upload file</label>
                                            <div className="UploadFileAreaSmall Height GreyColor rounded mb-4">
                                                <div id="fileuploader">
                                                    <div className="ajax-upload-dragdrop" style={{ verticalAlign: 'top', width: '100%' }}>
                                                        <div className="ajax-file-upload" style={{ position: 'relative', overflow: 'hidden', cursor: 'default' }}>
                                                            <p className="mb-2 CeraBold">PNG, GIF, WEBP, MP4 or MP3. Max 100mb.</p>
                                                            <form style={{ margin: '0px', padding: '0px' }}>
                                                                <input onChange={this.onUploadFile} type="file" accept="image/png, image/gif, image/jpeg, video/mp4" style={{ position: 'absolute', cursor: 'pointer', top: '0px', width: '100%', height: '100%', left: '0px', zIndex: '100', opacity: '0' }} />
                                                            </form>
                                                        </div>
                                                        <button type="button" className="mb-0 btn BtnBlack rounded-pill">Choose File</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between mb-3">
                                                <div className="">
                                                    <label className="form-label CeraMed d-block mb-0">Put on marketplace</label>
                                                    <small>Enter price to allow users instantly purchase your NFT</small>
                                                </div>
                                                <div className="form-check form-switch">
                                                    <input onChange={this.oc} name="isAvailableForMarket" className="form-check-input shadow-none cursor-pointer" type="checkbox"
                                                        id="putOnMarket" checked={isAvailableForMarket} />
                                                </div>
                                            </div>


                                            <React.Fragment>
                                                <label className="form-label CeraMed d-block mb-0">Price</label>
                                                <div className="input-group mb-3">
                                                    <input onChange={this.oc} value={this.state.data.price} name="price" type="number" className="form-control shadow-none"
                                                        placeholder="Enter price for one piece" />
                                                    <span className="input-group-text border-0">
                                                        <div className="dropdown bootstrap-select "> {/**dropup */}
                                                            <select className="SelectPicker" tabindex="null">
                                                                <option data-content="<img className='SelectPickerImg me-2 mb-1' src='images/icon-eth.png'><span className='text-dark'>ETH</span>"> Chrome</option>
                                                                <option data-content="<img className='SelectPickerImg me-2 mb-1' src='images/icon-dai.png'><span className='text-dark'>DAI</span>"> Chrome</option>
                                                                <option data-content="<img className='SelectPickerImg me-2 mb-1' src='images/icon-usdc.png'><span className='text-dark'>USDC</span>"> Chrome</option>
                                                            </select>
                                                            <button type="button" tabindex="-1" className="btn dropdown-toggle btn-light" data-bs-toggle="dropdown" role="combobox" aria-owns="bs-select-1" aria-haspopup="listbox" aria-expanded="false" title="NST">
                                                                <div className="filter-option">
                                                                    <div className="filter-option-inner">
                                                                        <div className="filter-option-inner-inner">
                                                                            <img className="SelectPickerImg me-2 mb-1" src="images/icon-dai.png" />
                                                                            <span className="text-dark">NST</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </span>
                                                </div>
                                                <label className="form-label CeraMed d-block GreyColor mb-1">Service fee <span
                                                    className="BlackColor CeraBold">0%</span></label>
                                                <label className="form-label CeraMed d-block GreyColor mb-0">You will receive <span
                                                    className="BlackColor CeraBold">{parseFloat(this.state.data.price || 0) - (parseFloat(this.state.data.price || 0) * 0)} NST </span></label>
                                            </React.Fragment>

                                        </div>


                                        <div className="mb-3">
                                            <label className="form-label CeraMed d-block mb-1">Title</label>
                                            <input onChange={this.oc} value={title} name="title" type="text" className="form-control shadow-none mb-3"
                                                placeholder="e.g Redeemable T-shirt with logo" />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label CeraMed d-block mb-1">Description</label>
                                            <textarea onChange={this.oc} value={description} name="description" rows="4" className="form-control shadow-none"
                                                placeholder="e.g. After purchasing you’ll be able to get the real T-Shirt"></textarea>
                                            <p className="form-text mb-0">With preserved line-breaks</p>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label CeraMed d-block mb-1">Royalties</label>
                                            <div className="input-group mb-3">
                                                <input onChange={this.oc} value={royalties} name='royalties' type="text" className="form-control shadow-none" placeholder="10" />
                                                <span className="input-group-text border-0" id="basic-addon1">%</span>
                                            </div>
                                            <p className="form-text">Suggested: 0%, 10%, 20%, 30%. Maximum is 50%</p>
                                        </div>
                                        <div className="mb-3">
                                            <button onClick={this.oc} name="showAdvance" type="button" className="btn BtnBorder w-100 py-2">{!this.state.showAdvance ? 'Show Advanced Settings' : 'Hide Advanced Settings'}
                                            </button>
                                        </div>
                                        <div className="mb-3">
                                            {
                                                this.state.showAdvance && (
                                                    <React.Fragment>
                                                        <label className="form-label CeraMed d-block mb-1">Properties <small className="GreyColor">(Optional)</small></label>
                                                        <div className="row gx-2">
                                                            <div className="col-xl-6">
                                                                <input onChange={(e) => {
                                                                    this.setState(prevState => ({
                                                                        data: {
                                                                            ...this.state.data,      // keep existing data fields like title, desc, etc.
                                                                            properties: {
                                                                                ...prevState.data.properties,
                                                                                size: e.target.value   // Changed from 'type' to 'size'
                                                                            }
                                                                        }
                                                                    }));
                                                                }} name="size" type="text" className="form-control shadow-none mb-3"
                                                                    placeholder="e.g. Size" />
                                                            </div>
                                                            <div className="col-xl-6">
                                                                <input onChange={(e) => {
                                                                    this.setState(prevState => ({
                                                                        data: {
                                                                            ...this.state.data,      // keep existing data fields like title, desc, etc.
                                                                            properties: {
                                                                                ...prevState.data.properties,
                                                                                type: e.target.value   // This one is correct
                                                                            }
                                                                        }
                                                                    }));
                                                                }} name="type" type="text" className="form-control shadow-none mb-3"
                                                                    placeholder="e.g. M" />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label CeraMed d-block mb-1">Alternative text for
                                                                NFT<small className="GreyColor"> (Optional)</small></label>
                                                            <textarea onChange={this.oc} name="alternativeText" rows="4" className="form-control shadow-none"
                                                                placeholder="Image description in details (do not start with word “image”)"></textarea>
                                                            <p className="form-text mb-0">Text that will be used in VoiceOver for people
                                                                with disabilities</p>
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }

                                            {
                                                this.state.isError && this.state.message && (
                                                    <div className="alert alert-danger" role="alert">
                                                        {this.state.message}
                                                    </div>
                                                )
                                            }
                                            {
                                                !this.state.isError && this.state.message && (
                                                    <div className="alert alert-success" role="alert">
                                                        {this.state.message}
                                                    </div>
                                                )
                                            }
                                            <div className="row justify-content-between align-items-center">
                                                <div className="col-md-auto mb-3 mb-md-0">
                                                    {/* || this.state.balance < 0.1 */}
                                                    <button disabled={this.state.isLoading} onClick={this.submit.bind(this)} type="button" className="btn BtnBlack py-2 px-5">Create item</button>
                                                </div>

                                                {this.state.balance !== null && this.state.balance < 0.1 && <label className="BlueColor">Balance is too low to make transaction. Balance: {this.state.balance}</label>}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="PreviewBoxSticky">
                                            <label className="form-label CeraMed">Preview</label>
                                            <div className="PreviewBox text-center rounded p-3 CeraBold GreyColor d-flex justify-content-center align-items-center">
                                                {
                                                    !this.state.imgSrc ? 'Upload file to preview your brand new NFT' : !isVideo(this.state.data.uploadType) ? (
                                                        <img className={'w-100 h-auto rounded'} src={this.state.imgSrc} />
                                                    ) : (
                                                        <video autoPlay className="w-100 rounded" loop muted>
                                                            <source src={this.state.imgSrc} type="video/mp4" />
                                                        </video>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>




                <KycStatus />
                {this.infoModal()}
                {this.confirmationModal()}
                {this.stepsModal()}
                <MissingMnemonics callback={(e) => this.submit(e)} />
                <NotLoggedInRedirection />
            </main>
        )
    }
}

const mapStateToProps = state => ({
    token: state.Auth.token,
    currentUser: state.Profile.profile,
    cypherSecret: state.Auth.cypherSecret,
    toggle: state.Settings.toggle
})

export default connect(mapStateToProps, { setCypherSecret })(Rea);